(function () {
  if (window.__arPpbExplainerV2) return;
  window.__arPpbExplainerV2 = true;

  function setLink(node, label, url) {
    if (!node) return;
    const visible = Boolean(label && url);
    node.hidden = !visible;
    node.textContent = visible ? label : "";
    if (visible) node.setAttribute("href", url);
    else node.removeAttribute("href");
  }

  function initRoute(root) {
    if (!root || root.dataset.ppbxRouteReady === "true") return;
    root.dataset.ppbxRouteReady = "true";

    const buttons = Array.from(root.querySelectorAll("[data-ppbx-route-choice]"));
    const answer = root.querySelector("[data-ppbx-route-answer]");
    const badge = root.querySelector("[data-ppbx-route-badge]");
    const title = root.querySelector("[data-ppbx-route-title]");
    const text = root.querySelector("[data-ppbx-route-text]");
    const primary = root.querySelector("[data-ppbx-route-primary]");
    const secondary = root.querySelector("[data-ppbx-route-secondary]");
    const states = {};
    let timer = 0;

    root.querySelectorAll("[data-ppbx-route-state]").forEach(function (node) {
      states[node.dataset.key] = {
        key: node.dataset.key,
        tone: node.dataset.tone || "neutral",
        badge: node.dataset.badge || "",
        title: node.dataset.title || "",
        text: node.dataset.text || "",
        primaryLabel: node.dataset.primaryLabel || "",
        primaryUrl: node.dataset.primaryUrl || "",
        secondaryLabel: node.dataset.secondaryLabel || "",
        secondaryUrl: node.dataset.secondaryUrl || ""
      };
    });

    function render(key, moveFocus) {
      const state = states[key];
      if (!state) return;

      buttons.forEach(function (button) {
        const active = button.dataset.ppbxRouteChoice === state.key;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
        if (active && moveFocus) button.focus();
      });

      if (answer) answer.classList.add("is-changing");
      window.clearTimeout(timer);

      window.requestAnimationFrame(function () {
        if (answer) answer.dataset.tone = state.tone;
        if (badge) badge.textContent = state.badge;
        if (title) title.textContent = state.title;
        if (text) text.textContent = state.text;
        setLink(primary, state.primaryLabel, state.primaryUrl);
        setLink(secondary, state.secondaryLabel, state.secondaryUrl);

        timer = window.setTimeout(function () {
          if (answer) answer.classList.remove("is-changing");
        }, 150);
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener("click", function () {
        render(button.dataset.ppbxRouteChoice, false);
      });

      button.addEventListener("keydown", function (event) {
        let nextIndex = null;
        if (event.key === "ArrowRight" || event.key === "ArrowDown") nextIndex = (index + 1) % buttons.length;
        if (event.key === "ArrowLeft" || event.key === "ArrowUp") nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = buttons.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        render(buttons[nextIndex].dataset.ppbxRouteChoice, true);
      });
    });
  }

  function initFaq(root) {
    if (!root || root.dataset.ppbxFaqReady === "true") return;
    root.dataset.ppbxFaqReady = "true";
    root.addEventListener(
      "toggle",
      function (event) {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.open) return;
        root.querySelectorAll("details[open]").forEach(function (other) {
          if (other !== item) other.open = false;
        });
      },
      true
    );
  }

  function initReveal(scope) {
    const nodes = Array.from(scope.querySelectorAll("[data-ppbx-reveal]")).filter(function (node) {
      return node.dataset.ppbxRevealReady !== "true" && !node.classList.contains("ppbx-hero");
    });
    if (!nodes.length) return;

    document.documentElement.classList.add("ppbx-reveal-ready");
    nodes.forEach(function (node) {
      node.dataset.ppbxRevealReady = "true";
    });

    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      nodes.forEach(function (node) {
        node.classList.add("is-visible");
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-ppbx-route]").forEach(initRoute);
    root.querySelectorAll(".ppbx-faq").forEach(initFaq);
    initReveal(root);
  }

  function boot() {
    init(document);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest("details");
    if (item) item.open = true;
  });
})();
